import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo.png";
import { useEffect } from "react";
import toggler from "../images/Icons/toggler.png";
import news from "../images/Icons/news.png";
import enquiry from "../images/Icons/enquiry.png";
import searchIcon from "../images/Icons/search.png";
import config from "../config";
import useLogout from "../View/Auth/useLogout";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NotificationBell from "../Component/NotificationBell";

export default function Header() {
  const user = config.user;
  const logout = useLogout();
  const [loading, setLoading] = useState(false);
  const handleLogout = async (e) => {
    e.preventDefault();
    setLoading(true);
    await logout(true);
    setLoading(false);
  };
  const [scrollToTop, setScrollToTop] = useState(false);
  useEffect(() => {
    if (scrollToTop) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setScrollToTop(false);
    }
  }, [scrollToTop]);
  const handleLogoClick = () => {
    setScrollToTop(true);
  };
  const handleMenuToggle = () => {
    const sideBar = document.querySelector(".mobile-menu-container");
    if (sideBar) {
      sideBar.scrollTop = 0;
    }
    document.body.classList.toggle("mmenu-active");
  };

  const [searchData, setSearchData] = useState("");
  const [dataLoading, setDataLoading] = useState(false);
  const [result, setResult] = useState({
    data: [],
    status: false,
  });
  const getData = useCallback(async (query) => {
    setDataLoading(true);
    try {
      const response = await axios.get(`${config.apiUrl}/general-search`, {
        params: { search_key: query },
      });
      setResult({
        data: response.data,
        status:
          response.data.brand_list.length > 0 ||
          response.data.product_list.length > 0 ||
          response.data.market_news.length > 0,
      });
    } catch (error) {
    } finally {
      setDataLoading(false);
    }
  }, []);
  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchData !== "") {
        getData(searchData);
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchData, getData]);

  const [mobileSearch, setMobileSearch] = useState(false);
  const toggleMobileSearch = () => {
    setMobileSearch(false);
    setSearchData("");
  };

  return (
    <>
      <header className="header header-2 header-intro-clearance">
        <div className="header-middle sticky-top-header">
          <div className="container-fluid">
            <div className="header-left">
              <button
                className="mobile-menu-toggler"
                onClick={handleMenuToggle}
              >
                <img src={toggler} alt="toggle" />
              </button>

              <Link to="/" onClick={handleLogoClick} className="logo">
                <img src={logo} alt="Biznie Logo" width="105" height="25" />
              </Link>
            </div>
            <div className="header-center">
              <div className="header-search d-none d-lg-block">
                <div className="header-search-wrapper dropdown">
                  <input
                    type="text"
                    className="form-control"
                    value={searchData}
                    onChange={(e) => setSearchData(e.target.value)}
                    placeholder="Search For Product, Brand And More"
                    id="searchDown"
                    data-bs-toggle="dropdown"
                  />
                  <button className="btn btn-primary" type="button" disabled>
                    <i className="bi bi-search"></i>
                  </button>

                  <div
                    className="search_result dropdown-menu"
                    aria-labelledby="searchDown"
                  >
                    {dataLoading ? (
                      <div className="d-flex justify-content-center">
                        <div className="search_loader"></div>
                      </div>
                    ) : result.status ? (
                      <>
                        {result.data.brand_list.length > 0 && (
                          <>
                            <h6 className="seprt">Brands</h6>
                            <div className="chip_group">
                              {result.data.brand_list.map((brand, index) => (
                                <Link
                                  to={`product-list/${brand.id}`}
                                  className="chip"
                                  key={index}
                                  onClick={toggleMobileSearch}
                                >
                                  {brand.name}
                                </Link>
                              ))}
                            </div>
                          </>
                        )}
                        {result.data.product_list.length > 0 && (
                          <>
                            <h6 className="seprt">Products</h6>
                            <div className="chip_group">
                              {result.data.product_list.map(
                                (product, index) => (
                                  <Link
                                    to={`product-list/${product.id}`}
                                    className="chip"
                                    key={index}
                                    onClick={toggleMobileSearch}
                                  >
                                    {product.name}
                                  </Link>
                                )
                              )}
                            </div>
                          </>
                        )}
                        {result.data.market_news.length > 0 && (
                          <>
                            <h6 className="seprt">Market News</h6>
                            <ul>
                              {result.data.market_news.map((news, index) => (
                                <li key={index}>
                                  <Link
                                    to={`news-detail/${news.slug}`}
                                    onClick={toggleMobileSearch}
                                  >
                                    {news.title}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </>
                        )}
                      </>
                    ) : (
                      <h6 className="no_result">Sorry, No Data Found !</h6>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="header-right">
              {user && user.priority && (
                <div className="account">
                  <div className="header-link priority-key-display">
                    <p>{user.priority} </p>
                    <i className="bi bi-star" style={{fontSize: '14px', color: '#dc3545'}}></i>
                  </div>
                </div>
              )}
              <div className="account">
                <Link to="/news-list">
                  <div className="header-link">
                    <img src={news} alt="" className="img-icon" />
                    <p>News</p>
                  </div>
                </Link>
              </div>
              <div className="account">
                <Link to="/enquiry">
                  <div className="header-link">
                    <img src={enquiry} alt="" className="img-icon" />
                    <p>Enquiry</p>
                  </div>
                </Link>
              </div>

              <NotificationBell />

              <div className="dropdown profile-dropdown">
                <button
                  className="dropdown-toggle header-link header-button"
                  type="button"
                  title="Profile"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-display="static"
                >
                  <p>Profile</p>
                  <i className="bi bi-person-circle"></i>
                </button>

                <div className="dropdown-menu dropdown-menu-right">
                  {user ? (
                    <>
                      <h4>Welcome</h4>
                      <p>{user.name}</p>
                      {user.kyc_status && (
                        <p className="text-capitalize text-muted">KYC : {user.kyc_status}</p>
                      )}
                      <button
                        type="button"
                        title="logout"
                        className="profile_btn"
                        onClick={handleLogout}
                        disabled={loading}
                      >
                        Logout
                      </button>
                    </>
                  ) : (
                    <>
                      <h4>Hello User</h4>
                      <p>Login to access your account</p>
                      <Link
                        type="button"
                        className="profile_btn"
                        title="login"
                        to="/login"
                      >
                        Login/Register
                      </Link>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="mobile-searchBar">
              <button
                className="search-toggle"
                title="Search"
                onClick={() => setMobileSearch(true)}
              >
                <img src={searchIcon} className="img-fluid" alt="" />
              </button>
              {mobileSearch && (
                <div className="search-overlay">
                  <div className="search-overlay-content">
                    <div className="close">
                      <button onClick={toggleMobileSearch} type="button">
                        <i className="bi bi-x-lg"></i>
                      </button>
                    </div>
                    <div className="search-overlay-form">
                      <input
                        type="text"
                        className="form-control"
                        value={searchData}
                        onChange={(e) => setSearchData(e.target.value)}
                        placeholder="Search For Product, Brand And More"
                      />
                      <button className="search" type="button" disabled>
                        <i className="bi bi-search"></i>
                      </button>
                    </div>
                    {dataLoading ? (
                      <div className="d-flex justify-content-center">
                        <div className="search_loader"></div>
                      </div>
                    ) : result.status ? (
                      <>
                        {result.data.brand_list.length > 0 && (
                          <>
                            <h6 className="seprt">Brands</h6>
                            <div className="chip-group">
                              {result.data.brand_list.map((brand, index) => (
                                <Link
                                  to={`product-list/${brand.id}`}
                                  className="chip"
                                  key={index}
                                  onClick={toggleMobileSearch}
                                >
                                  {brand.name}
                                </Link>
                              ))}
                            </div>
                          </>
                        )}
                        {result.data.product_list.length > 0 && (
                          <>
                            <h6 className="seprt">Products</h6>
                            <div className="chip-group">
                              {result.data.product_list.map(
                                (product, index) => (
                                  <Link
                                    to={`product-list/${product.id}`}
                                    className="chip"
                                    key={index}
                                    onClick={toggleMobileSearch}
                                  >
                                    {product.name}
                                  </Link>
                                )
                              )}
                            </div>
                          </>
                        )}
                        {result.data.market_news.length > 0 && (
                          <>
                            <h6 className="seprt">Market News</h6>
                            <ul className="suggestions-list">
                              {result.data.market_news.map((news, index) => (
                                <li key={index}>
                                  <Link
                                    to={`news-detail/${news.slug}`}
                                    onClick={toggleMobileSearch}
                                  >
                                    {news.title}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </>
                        )}
                      </>
                    ) : (
                      <h6 className="no_result">Sorry, No Data Found !</h6>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
